import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, OrderCustomerModel } from 't4core';
import { FormArray, FormBuilder, FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { ReceiverType, Receiver } from 't4core';
import { T4ListItem } from '../../../../../projects/t4core/src/public-api';
import { group } from 'console';



@Component({
  selector: 'NewCustomerDialog',
  templateUrl: 'NewCustomerDialog.html',
  styleUrls: ['NewCustomerDialog.css']
})
export class NewCustomerDialog extends DialogBase implements OnInit {

  public customer: OrderCustomerModel;
  public comments: string;
  public loading: boolean;
  public saveDirty: boolean = false;

  @ViewChild("txtChain") private txtChain: NgModel;
  @ViewChild("txtOrgNo") private txtOrgNo: NgModel;
  @ViewChild("txtFilial") private txtFilial: NgModel;
  @ViewChild("txtComments") private txtComments: NgModel;

  @ViewChild("txtInvoiceName") private txtInvoiceName: NgModel;
  @ViewChild("txtInvoiceAddress") private txtInvoiceAddress: NgModel;
  @ViewChild("txtInvoiceZipCode") private txtInvoiceZipCode: NgModel;
  @ViewChild("txtInvoiceCity") private txtInvoiceCity: NgModel;
  @ViewChild("txtInvoiceEmail") private txtInvoiceEmail: NgModel;

  @ViewChild("txtDeliveryName") private txtDeliveryName: NgModel;
  @ViewChild("txtDeliveryAddress") private txtDeliveryAddress: NgModel;
  @ViewChild("txtDeliveryZipCode") private txtDeliveryZipCode: NgModel;
  @ViewChild("txtDeliveryCity") private txtDeliveryCity: NgModel;
  @ViewChild("txtDeliveryPhone") private txtDeliveryPhone: NgModel;
  @ViewChild("txtDeliveryEmail") private txtDeliveryEmail: NgModel;


  @ViewChild('groupInput') private groupInput: ElementRef<HTMLInputElement>;
  groupControl = new FormControl('');
  groupOptions: T4ListItem[] = [];
  filteredGroupOptions: T4ListItem[];

  @ViewChild('chainInput') private chainInput: ElementRef<HTMLInputElement>;
  chainControl = new FormControl('');
  chainOptions: string[] = [];
  filteredChainOptions: string[] = [];

  // Form Groups
  invoiceForm: FormGroup = new FormGroup({});
  deliveryForm: FormGroup = new FormGroup({});
  customerForm: FormGroup = new FormGroup({});
  paymentForm: FormGroup;

  payoutOptions = ['Other', 'BG', 'IBAN', 'SWIFT',];

    constructor(
        public dialogRef: MatDialogRef<NewCustomerDialog>,
        private fb: FormBuilder,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("NewCustomerDialog");

        this.filteredGroupOptions = this.groupOptions.slice();
        this.filteredChainOptions = this.chainOptions.slice();
    }


  public async ngOnInit() {
    this.initiateformGroups();

    this.customer = new OrderCustomerModel();
      this.getGroups();
      this.getChains();
  }


  private async getGroups() {
      var groups = await this.Api.get<T4ListItem[]>("TurboOrder/GetAllGroups");
      groups = groups.filter(x => !x.Name.includes("...")); //Removes the all the unused stations, and default that should not be used.
      this.groupOptions = groups;
  }

    private async getChains() {
        this.chainOptions = await this.Api.get<string[]>("TurboOrder/GetChains");
  }

    groupFilter(): void {
        const filterValue = this.groupInput.nativeElement.value.toLowerCase();
        this.filteredGroupOptions = this.groupOptions.filter(o => o.Name.toLowerCase().includes(filterValue));
    }

    chainFilter(): void {
        const filterValue = this.chainInput.nativeElement.value.toLowerCase();
        this.filteredChainOptions = this.chainOptions
            .filter(o => typeof o === 'string' && o.toLowerCase().includes(filterValue)); 
    }


  public save() {
    this.saveDirty = true;

    this.customerForm.markAllAsTouched();
    this.deliveryForm.markAllAsTouched();
    this.invoiceForm.markAllAsTouched();

    //If any of the forms is not valid, we dont do anything and the panels will be red that are missing Info.
    if (!this.customerForm.valid ||
      !this.deliveryForm.valid ||
      !this.invoiceForm.valid ||
      (this.customerForm.get('Payment')?.value && !this.paymentForm.valid)) return;

    var str = "";

    // Customer Form
    const customer = this.customerForm.value;
    str += `Chain: ${customer.Chain}<br/>`;
    str += `Org.No: ${customer.OrgNo}<br/>`;
    str += `Filial: ${customer.FilialNr}<br/>`;
    str += `Comments: ${customer.Comment || ''}<br/>`;

    // Invoice Form
    str += `<br/><h3>Invoice</h3><br/>`;
    const invoice = this.invoiceForm.value;
    str += `Name: ${invoice.InvoiceName}<br/>`;
    str += `Address: ${invoice.InvoiceAddress}<br/>`;
    str += `ZipCode: ${invoice.InvoiceZipCode}<br/>`;
    str += `City: ${invoice.InvoiceCity}<br/>`;
    str += `Email: ${invoice.Mail}<br/>`;

    // Delivery Form
    str += `<br/><h3>Delivery</h3><br/>`;
    const delivery = this.deliveryForm.value;
    str += `Name: ${delivery.DeliveryAddressCustomerName}<br/>`;
    str += `Address: ${delivery.DeliveryAddress}<br/>`;
    str += `ZipCode: ${delivery.DeliveryZipCode}<br/>`;
    str += `City: ${delivery.DeliveryCity}<br/>`;
    str += `Email: ${delivery.InvoiceAccount}<br/>`;
    str += `Phone: ${delivery.Phone}<br/>`;

    // Payment Form
    if (this.customerForm.get('Payment')?.value) {
      str += `<br/><h3>Payment</h3><br/>`;

      const payouts = this.paymentForm.get('payouts')?.value;

      if (payouts && payouts.length > 0) {
        payouts.forEach((payout: { type: string; payoutInfo: string }) => {
          str += `Type: ${payout.type} - Payout Info: ${payout.payoutInfo}<br/>`;
        });
      }
    }

    var receiver = new Receiver();
    receiver.Type = ReceiverType.Email;
    receiver.ReceiverId = "order@brenderuprental.com;mats@slapservice.com";

    this.Api.post<boolean>("Messaging/PlaceMessage", [receiver], { subject: "New Customer", content: str, language: "en", validFrom: null, validTo: null, priority: 10, requireConfirmation: false });
    this.UI.snackBar("Customer has been sent. You will be notified when ready!");
    this.close();
  }
    
    public close() {
        this.dialogRef.close();
    }


  public initiateformGroups() {

    this.paymentForm = this.fb.group({
      payouts: this.fb.array([])
    });

      this.invoiceForm = this.fb.group({
        InvoiceName: ['', Validators.required],
        InvoiceAddress: ['', Validators.required],
        InvoiceZipCode: ['', Validators.required],
        InvoiceCity: ['', Validators.required],
        Mail: ['', [Validators.required, Validators.email]],
      });

      this.deliveryForm = this.fb.group({
        DeliveryAddressCustomerName: ['', Validators.required],
        DeliveryAddress: ['', Validators.required],
        DeliveryZipCode: ['', Validators.required],
        DeliveryCity: ['', Validators.required],
        InvoiceAccount: ['', [Validators.required, Validators.email]],
        Phone: ['', [Validators.required, Validators.pattern(/^\+?\d{8,15}$/)]], 
      });

      this.customerForm = this.fb.group({
        Group: ['', Validators.required],
        Chain: ['', Validators.required],
        OrgNo: ['', Validators.required],
        FilialNr: ['', Validators.required],
        Comment: [''],
        Payment: [false]
      })
    }


    // Payment Settings
    get payouts() {
      if (this.paymentForm.get('payouts'))
        return this.paymentForm.get('payouts') as FormArray;
        else return null;
    }

    createPayoutGroup(type: string = '', payoutInfo: string = '') {

        if (!type) {
            const selectedTypes = this.getSelectedTypes().filter(type => type !== 'Other');
            type = this.payoutOptions.find(option => option === 'Other' || !selectedTypes.includes(option)) || '';
        }

        return this.fb.group({
            type: [type, Validators.required],
            payoutInfo: [payoutInfo, Validators.required]
        });
    }


    addInput() {
        this.payouts.push(this.createPayoutGroup());
    }

    getSelectedTypes() {
        return this.payouts.controls.map(control => control.get('type')?.value);
    }

    getAvailableOptions(selectedType?: string): string[] {
        const selectedTypes = this.getSelectedTypes().filter(type => type !== 'Other');

        return this.payoutOptions.filter(option => option === 'Other' || selectedTypes.indexOf(option) === -1 || option === selectedType);
    }

    removeInput(index: number) {
        this.payouts.removeAt(index);
    }

}
